import { UpdateProfileResponseContent } from "@equaliq/api-model";
import { UserAccountState } from "src/enums/shared.enums";
import { createApiRequest } from "../common";

// Define the profile update DTO
export interface UpdateProfileDto {
  firstName: string;
  lastName: string;
  displayName: string;
  accountType: string;
  state: UserAccountState;
  bio?: string;
  profilePicture?: File;
  isOver18?: boolean;
}

export const updateProfileApi = async (
  data: UpdateProfileDto
): Promise<UpdateProfileResponseContent> => {
  const request = createApiRequest<UpdateProfileResponseContent>('post', '/updateProfile');
  return request(data);
};